import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/views/layout/index'

Vue.use(Router)
const ShopRouter =[
  {
    path: '/',
    component: Layout,
    name: 'onlineShop',
    children: [
      {
        path: '/onlineShopList',
        component: () => import('@/views/onlineShop/onlineShopList'), // 商品列表
        name: 'onlineShopList'
      },
      {
        path: '/onlineShopDetail/:id',
        component: () => import('@/views/onlineShop/onlineShopDetail'), // 商品详情
        name: 'onlineShopDetail'
      }
    ]
	}
]

export default ShopRouter


// WEBPACK FOOTER //
// ./src/router/onlineShop.js